<template>
  <Card
    v-bind="$attrs"
    clickable
    :morph="quotation.timeline_morph"
    :pinned="quotation.timeline_pinned"
    :simple="simple"
    @click="viewingQuotationID = quotation.id"
  >
    <q-item-section>
      <div class="text-caption text-bold q-mb-xs">
        <span v-if="fullDate" class="q-pr-xs">
          ({{ $formatSystemDate(quotation.timeline_date, luxonFormats.SHORT_WORDED_DATE) }})
        </span>
        Quotation
      </div>
      <q-item-label v-if="quotation.address" class="module-name">
        {{ quotation.address }}
      </q-item-label>
      <q-item-label caption>
        {{ quotation.quotation_number }}
      </q-item-label>
      <Status
        flat
        :quotation="quotation"
        class="q-mt-sm lt-sm"
      />
    </q-item-section>
    <q-item-section
      v-if="quotation.client"
      side
      class="text-right gt-xs"
      :title="quotation.client"
    >
      {{ truncateString(quotation.client) }}
    </q-item-section>
    <q-item-section
      side
      style="min-width: 90px;"
      class="text-right"
    >
      <q-item-label class="text-bold">
        {{ friendlyNumber(quotation.total, true) }}
      </q-item-label>
    </q-item-section>
    <q-item-section
      side
      style="min-width: 85px;"
      class="q-pl-sm gt-xs"
    >
      <Status :quotation="quotation" />
    </q-item-section>
  </Card>

  <QuotationDialog
    :id="viewingQuotationID"
    without-appointment
    without-client
    :disable-editing="false"
    @deleted="markArchived"
    @close="viewingQuotationID = null"
  />
</template>

<script>
import { defineAsyncComponent } from 'vue'

import Status from 'components/app/quotations/partials/Status'
import Card from 'components/partials/timeline/partials/Card'
import cardMixin from 'components/partials/timeline/partials/cardMixin'

export default {
  components: {
    Card,
    Status,
    QuotationDialog: defineAsyncComponent(() => import('src/components/app/quotations/partials/view/Dialog'))
  },
  mixins: [cardMixin],
  props: {
    quotation: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      viewingQuotationID: null
    }
  },
  methods: {
    markArchived () {
      this.quotation.archived = true
    }
  }
}
</script>
